import { BiddingGame, biddingGameNull } from '../models/bidding-game'
import { GetBiddingGameErrorCode } from '../error-codes/get-bidding-game.error-code'
import { GamePlayConfig, QueryResponse } from 'shared-services'
import { GamePlayGameId } from '../models/game-play-game-id'
import { BiddingGameDto } from '../dtos/bidding-game.dto'
import { biddingGameMapper } from '../mappers/bidding-game.mapper'
import { BidType } from '../types/bid.type'

export class BiddingService {
  public constructor(private readonly gamePlayConfig: GamePlayConfig) {}

  public async getBiddingGame(
    gamePlayGameId: GamePlayGameId,
  ): Promise<QueryResponse<BiddingGame, GetBiddingGameErrorCode>> {
    const gamePlayId = gamePlayGameId.gamePlayId
    const gameId = gamePlayGameId.gameId
    const query = `gamePlayId=${gamePlayId}&gameId=${gameId}`

    const response = await fetch(
      `${this.gamePlayConfig.apiBaseUrl}/bidding/v1/bidding-game?${query}`,
      {
        credentials: 'include',
      },
    )

    const biddingGameResponse = (await response.json()) as QueryResponse<
      BiddingGameDto,
      GetBiddingGameErrorCode
    >

    const result = biddingGameResponse.isSuccessful
      ? biddingGameMapper.mapToBiddingGame(biddingGameResponse.result)
      : biddingGameNull

    return {
      errorCode: biddingGameResponse.errorCode,
      errorCodes: biddingGameResponse.errorCodes,
      isSuccessful: biddingGameResponse.isSuccessful,
      result,
    }
  }

  public async placeBid(
    gamePlayGameId: GamePlayGameId,
    bidType: BidType,
  ): Promise<void> {
    const gamePlayId = gamePlayGameId.gamePlayId
    const gameId = gamePlayGameId.gameId

    const body = {
      gamePlayId,
      gameId,
      bid: bidType,
    }

    await fetch(`${this.gamePlayConfig.apiBaseUrl}/bidding/v1/place-bid`, {
      method: 'POST',
      body: JSON.stringify(body),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  public async passBid(gamePlayGameId: GamePlayGameId): Promise<void> {
    const gamePlayId = gamePlayGameId.gamePlayId
    const gameId = gamePlayGameId.gameId

    const body = {
      gamePlayId,
      gameId,
    }

    await fetch(`${this.gamePlayConfig.apiBaseUrl}/bidding/v1/pass-bid`, {
      method: 'POST',
      body: JSON.stringify(body),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }
}
